import { Mail, Phone, Facebook, Instagram } from "lucide-react";

const Categories = [
  {
    title: "Shilajit",
    url: "https://www.daburshop.com/collections/dabur-shilajit",
  },
  {
    title: "Air Freshner",
    url: "https://www.daburshop.com/collections/air-fresheners",
  },
  {
    title: "Oral Care",
    url: "https://www.daburshop.com/collections/oral-care",
  },
  {
    title: "Baby Care",
    url: "https://www.daburshop.com/collections/baby-care",
  },
  {
    title: "Skin Care",
    url: "https://www.daburshop.com/collections/skin-care",
  },
  {
    title: "Chyawanprash",
    url: "https://www.daburshop.com/collections/chyawanprash",
  },
  {
    title: "Hair Care",
    url: "https://www.daburshop.com/collections/hair-care",
  },
  { title: "Culinary", url: "https://www.daburshop.com/collections/Culinary" },
  { title: "Juices", url: "https://www.daburshop.com/collections/beverages" },
];

const quickLinks = [
  { title: "About Us", url: "https://www.daburshop.com/pages/about-us" },
  {
    title: "Terms of Use",
    url: "https://www.daburshop.com/pages/terms-conditions",
  },
  { title: "My Account", url: "https://www.daburshop.com/account" },
  { title: "Contact Us", url: "https://www.daburshop.com/pages/contact" },
  { title: "Privacy Policy", url: "https://www.daburshop.com/pages/privacy-policy" },
  { title: "Shipping Policy", url: "https://www.daburshop.com/pages/shipping-policy" },
  {
    title: "Returns, Refunds & Cancellation",
    url: "https://www.daburshop.com/pages/cancellation-refund-policy",
  },
  { title: "Cookie Policy", url: "https://www.daburshop.com/pages/cookie-policy" },
];

export default function FooterAdmin() {
  return (
    <footer className="relative bg-[#44633f] text-gray-100 pt-16 pb-10 mt-16 overflow-hidden">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>

      <div className="relative container mx-auto px-6 lg:px-12">
        {/* Grid Layout (4 Sections) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12">
          {/* Popular Categories */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative after:content-[''] after:block after:w-12 after:h-[2px] after:bg-[#ffffff] after:mt-2">
              Popular Categories
            </h3>
          <ul className="space-y-2 text-sm">
              {Categories.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.url}
                    className="hover:text-[#ffffff] cursor-pointer transition-colors duration-200"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative after:content-[''] after:block after:w-12 after:h-[2px] after:bg-[#ffffff] after:mt-2">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm">
             {quickLinks.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.url}
                    className="hover:text-[#ffffff] cursor-pointer transition-colors duration-200"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative after:content-[''] after:block after:w-12 after:h-[2px] after:bg-[#ffffff] after:mt-2">
              Contact Us
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#ffffff]" />
                <a
                  href="mailto:cares@daburshop.com"
                  className="hover:underline"
                >
                  cares@daburshop.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#ffffff]" />
                <a href="tel:18005728559" className="hover:underline">
                  18005728559
                </a>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4 relative after:content-[''] after:block after:w-12 after:h-[2px] after:bg-[#ffffff] after:mt-2">
              Follow Us
            </h3>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/daburshop/"
                target="_blank"
                className="p-3 bg-white/10 rounded-full hover:bg-[#ffffff] hover:text-[#44633f] transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/daburshop/"
                target="_blank"
                className="p-3 bg-white/10 rounded-full hover:bg-[#ffffff] hover:text-[#44633f] transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-10 border-white/20" />

        {/* Bottom Section */}
        <div className="text-center md:text-left text-sm text-gray-200 flex flex-col md:flex-row justify-between items-center gap-3">
          <p>
            © {new Date().getFullYear()}{" "}
            <span className="font-semibold text-white">The Techtonic</span>. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
